<!--
# Frontend Vue | Vendor: FairVerify | App: Phoenix | Type: VisitorLeadModal
# FairVerify Event Solutions (fairverify.de) based on GodMode Core - GodMode.Systems
# Copyright Tim Haymann, FairVerify Event Solutions GmbH.
-->
<template>
  <div v-if="modal.visible">
    <div class="modal d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 rounded-4">
          <div class="modal-body text-center pt-4 pb-3 px-4">
            <div
              class="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3 fs-4"
              style="width:4rem;height:4rem"
              :class="iconBgClass"
            >
              <i :class="iconClass"></i>
            </div>
            <h2 class="h4">{{ modal.title }}</h2>
            <p class="text-muted mb-4">{{ modal.text }}</p>
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <button class="btn btn-primary rounded-pill px-4" type="button" @click="$emit('primary')">
                {{ modal.primaryLabel }}
              </button>
              <button
                v-if="modal.secondaryLabel"
                class="btn btn-outline-secondary rounded-pill px-4"
                type="button"
                @click="$emit('secondary')"
              >
                {{ modal.secondaryLabel }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  name: 'VisitorLeadModal',
  props: {
    modal: {
      type: Object,
      default: () => ({
        visible: false,
        variant: 'info',
        title: '',
        text: '',
        primaryLabel: '',
        secondaryLabel: '',
      }),
    },
  },
  computed: {
    iconClass() {
      if (this.modal.variant === 'success') return 'fas fa-check'
      if (this.modal.variant === 'error') return 'fas fa-exclamation'
      return 'fas fa-info'
    },
    iconBgClass() {
      if (this.modal.variant === 'success') return 'bg-success bg-opacity-10 text-success'
      if (this.modal.variant === 'error') return 'bg-danger bg-opacity-10 text-danger'
      return 'bg-primary bg-opacity-10 text-primary'
    },
  },
}
</script>
